import {
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import profilepic from "../assets/home.jpg";
import EricClassVideo from "../assets/EG-class.mp4";
import LineBreak from "./LineBreak";

export default function Intro() {
  const { t } = useTranslation();
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        backgroundRepeat: "no-repeat",

        backgroundImage:
          "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)",
        ...theme.applyStyles("dark", {
          backgroundImage:
            "radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)",
        }),
      })}
    >
      <Box
        id="about"
        sx={{
          pt: { xs: 14, md: 20 },
          px: { xs: 2, md: 0 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card
          elevation={3}
          sx={{
            width: { xs: "100%", lg: "60%" },
            borderRadius: 3,
          }}
        >
          <CardContent sx={{ p: { xs: 3 } }}>
            <Grid container spacing={4} alignItems="center">
              {/* Left: Avatar */}
              <Grid
                size={{ xs: 12, md: 5 }}
                display="flex"
                justifyContent="center"
              >
                <Box
                  component="img"
                  alt="Profile picture"
                  src={profilepic}
                  sx={{
                    width: { xs: "60%", md: "100%" },
                    height: "auto",
                    borderRadius: "5rem",
                  }}
                />
              </Grid>

              {/* Right: Introduction text */}
              <Grid size={{ xs: 12, md: 7 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                  {t("home.name")}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ lineHeight: 1.2 }}
                >
                  <Trans
                    i18nKey="home.bio"
                    components={{
                      br: <LineBreak />,
                    }}
                  />
                </Typography>
                <Grid container spacing={2} sx={{ mt: 3 }} alignItems="center">
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Button
                      variant="contained"
                      size="large"
                      href="/training/overview"
                      color="primary"
                      fullWidth
                      sx={{ textAlign: "center" }}
                    >
                      {t("home.trainingBtnTitle")}
                    </Button>
                  </Grid>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <Button
                      variant="contained"
                      size="large"
                      href="mailto:sharkshooter2011@gmail.com"
                      color="primary"
                      target="_blank"
                      rel="noopener"
                      fullWidth
                      sx={{ textAlign: "center" }}
                    >
                      {t("home.partnershipsBtnTitle")}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <Box
        id="intro-video"
        sx={{
          pt: { xs: 5 },
          px: { xs: 2, md: 0 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card
          elevation={0}
          sx={{
            width: { xs: "100%", lg: "75%" },
            borderRadius: 1,
          }}
        >
          <video
            loop
            controls
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          >
            <source src={EricClassVideo} type="video/mp4" />
          </video>
        </Card>
      </Box>
    </Box>
  );
}
